import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class UserUpdate extends HttpForm {
    id;
    data = false;
    constructor(params) {
        super();
        this.id = params.id;
    }
    mount() {
        return this.get()
            .then((response) => {
            this.data = response.data.data;
            this.setLoadingState(true);
        })
            .catch(e => this.setError(e));
    }
    get() {
        const url = '/api/user/' + this.id;
        return axios.get(url).catch(e => this.setError(e));
    }
    update() {
        const url = '/api/user/' + this.id;
        this.setupFormSubmission();
        return axios.patch(url, this.data)
            .then(() => this.setSuccessMessage('User updated.'))
            .catch(e => this.setError(e));
    }
}
